import { FocusContext, useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import { useCallback, useEffect, useRef, useState } from "react";
import { ANALYTICS_EVENTS, CURRENT_PAGE, LOCAL_STORAGE_KEY, PLAYER } from "../../../constant";
import { getPage, removeDevice } from "../../../Api/api";
import 'material-symbols';
import { utility } from "../../../utility/utility";
import { useNavigate } from "react-router";
import crown from '../../../images/crown.png';
import LogoutConfirmationBox from "../components/LogoutConfirmationBox";
import ProfileWeb from "../components/ProfileWeb";
import TooltipWeb from "../components/TooltipWeb";
import RoundButtonWeb from "../components/RoundButtonWeb";
import { useDispatch, useSelector } from "react-redux";
import Smiley from "../../profile/components/Smiley";
import { resetApplication } from "../../../redux/applicationSlice";
import AnalyticsManager from "../../../analytics/analyticsManager";

function MenuItem({ hasFocusedChild, onClick, onMouseFocus, menuSettings, item, index, setSelectedMenu, currentPage, selectedItemRef }) {
    const { ref, focused } = useFocusable();
    const [onMenuItemMouseFocus, setOnMenuItemMouseFocus] = useState(false);

    //if focused
    useEffect(() => {
        if (focused || onMenuItemMouseFocus) {
            setSelectedMenu(item, index);
        }
    }, [focused, onMenuItemMouseFocus]);

    let isSelectedMenu = currentPage._id == item._id;

    return (
        <div
            onMouseEnter={() => setOnMenuItemMouseFocus(true)}
            onMouseLeave={() => setOnMenuItemMouseFocus(false)}
            onClick={onClick}
            key={index}
            style={{
                minWidth: "100px",
                height: "50px",
                backgroundColor: "transparent",
                borderRadius: "4px",
                marginRight: "0px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                transition: "all 0.2s ease-in-out",
                padding: "8px 16px",
                position: "relative",
                color: isSelectedMenu ? "#ffffff" : (onMenuItemMouseFocus ? "#ffffff" : "#b0b0b0"),
                fontWeight: isSelectedMenu ? "600" : "400"
            }}
            id={item._id}
            focused={focused}
            data-menu-index={index}
        >
            <span
                style={{
                    fontSize: "14px",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "120px",
                    transition: "all 0.2s ease-in-out"
                }}
            >
                {item?.displayName ?? ""}
            </span>
        </div>
    );
}

function ActionButton({ icon, text, onClick, focused, onMouseEnter, onMouseLeave }) {
    return (
        <div
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            style={{
                minWidth: "90px",
                height: "36px",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                transition: "all 0.2s ease-in-out",
                padding: "0 16px",
                color: "#ffffff",
                fontSize: "13px",
                fontWeight: "500",
                transform: focused ? "scale(1.05)" : "scale(1)",
                borderColor: focused ? "rgba(255, 255, 255, 0.5)" : "rgba(255, 255, 255, 0.2)",
                backgroundColor: focused ? "rgba(255, 255, 255, 0.15)" : "rgba(255, 255, 255, 0.1)"
            }}
        >
            {icon && (
                <span
                    className="material-symbols-outlined"
                    style={{
                        fontSize: "18px",
                        marginRight: text ? "8px" : "0"
                    }}
                >
                    {icon}
                </span>
            )}
            {text && <span>{text}</span>}
        </div>
    );
}

const NmLogo = ({ src, width, showCrown }) => <div style={{ position: "relative" }}>
    <img src={src} style={{
        width: width * 3,
        marginBottom: " 10px",
        padding: "0 10px",
        objectFit: "contain",
    }} /></div>;

export default function TopMenuWeb({ focusKey: focusKeyParam, ottSetting, menu, setCurrentPage, currentPage, setIsLoading, setCurrentPageUnderMenu }) {
    const {

        focusSelf,
        hasFocusedChild,
        focusKey
    } = useFocusable({
        focusable: true,
        saveLastFocusedChild: false,
        trackChildren: true,
        autoRestoreFocus: true,
        isFocusBoundary: false,
        focusKey: focusKeyParam,
        preferredChildFocusKey: null,
        onArrowPress: () => true,
    });

    const selectedMenu = useRef({});
    const isLoginRef = useRef(utility.getValue(LOCAL_STORAGE_KEY.user) !== null);
    const user = utility.getValue(LOCAL_STORAGE_KEY.user);
    const [selectedItemIndex, setSelectedItemIndex] = useState(0);
    const [underlineStyle, setUnderlineStyle] = useState({});
    const menuContainerRef = useRef(null);
    const [showConfirmLogout, setShowConfirmLogout] = useState(false);
    const { selectedProfile, ottSettings } = useSelector((state) => state.application);
    const dispatch = useDispatch();
    const setSelectedMenu = (menu, index) => {
        selectedMenu.current = menu;
        if (index !== undefined) {
            setSelectedItemIndex(index);

        }
        document.getElementById(menu._id)?.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center"
        });
    }

    const updateUnderlinePosition = (index) => {
        if (menuContainerRef.current) {
            const menuItems = menuContainerRef.current.querySelectorAll('[data-menu-index]');
            if (menuItems[index]) {
                const menuItem = menuItems[index];
                const containerRect = menuContainerRef.current.getBoundingClientRect();
                const itemRect = menuItem.getBoundingClientRect();

                const left = itemRect.left - containerRect.left;
                const width = itemRect.width;

                setUnderlineStyle({
                    position: 'absolute',
                    bottom: '5px',
                    left: `${left + width * 0.1}px`,
                    width: `${width * 0.8}px`,
                    height: '2px',
                    backgroundColor: '#ffffff',
                    borderRadius: '2px',
                    transition: 'all 0.3s ease-out',
                    transform: 'translateZ(0)' // Force hardware acceleration
                });
            }
        }
    };

    // Find the initial selected item index
    useEffect(() => {
        const filteredMenu = menu.filter(item => item._id !== "search" && item._id !== "login" && item._id !== "logout");
        const currentIndex = filteredMenu.findIndex(item => item._id === currentPage._id);
        if (currentIndex >= 0) {
            setSelectedItemIndex(currentIndex);
            // Delay to ensure DOM is ready
            setTimeout(() => updateUnderlinePosition(currentIndex), 100);
        }
    }, [currentPage._id, menu]);

    // Update underline position when window resizes
    useEffect(() => {
        const handleResize = () => {
            updateUnderlinePosition(selectedItemIndex);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [selectedItemIndex]);

    const [onMouseFocus, setOnMouseFocus] = useState(false);
    const [searchFocused, setSearchFocused] = useState(false);
    const [loginFocused, setLoginFocused] = useState(false);
    const [profileFocused, setProfileFocused] = useState(false);
    const [showProfile, setShowProfile] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        focusSelf();
    }, [focusSelf]);

    useEffect(() => {
        if (hasFocusedChild) {
            window.addEventListener('keydown', onKeyPress);
        } else {
            window.removeEventListener('keydown', onKeyPress)
        }

        return () => {
            window.removeEventListener('keydown', onKeyPress);
        }
    }, [hasFocusedChild]);

    const onKeyPress = useCallback(async ({ keyCode }) => {
        if (keyCode === PLAYER.ENTER) {
            setCurrentPageUnderMenu(CURRENT_PAGE.MAIN);
            let user = utility.getValue(LOCAL_STORAGE_KEY.user);

            if (selectedMenu.current._id == "myDevices") {
                if (!user) {
                    navigate('/login');
                    return;
                }
                navigate('/removeDevice', { state: { user: user, fromLogin: false } });
                return;
            }

            if (selectedMenu.current._id == "logout" || selectedMenu.current._id == "login") {
                if (selectedMenu.current._id == "logout") {
                    try {
                        let ipaddressRes = await fetch('https://api.ipify.org?format=json');
                        let ipaddress = await ipaddressRes.json().then((data) => data['ip']);
                        let res = await removeDevice(user._id, ipaddress);
                        utility.setValue(LOCAL_STORAGE_KEY.user, null);
                        navigate('/login');
                        console.log(res.message);
                        return;
                    } catch (error) {
                        console.log("error while logout ", error.message);
                    }
                } else {
                    utility.deleteValue(LOCAL_STORAGE_KEY.user);
                    navigate('/login');
                    return;
                }
            }

            if (selectedMenu.current._id == "search") {
                navigate('/search');
                return;
            }

            setIsLoading(true);
            let res = await getPage(selectedMenu.current._id);
            setIsLoading(false);
            if (res.success) {
                // navigate('/');
                setCurrentPage(res.data);
            } else {
                console.log("Page not found");
            }
        }
    }, [navigate, setCurrentPage]);

    const onClick = () => {
        // Analytics event
        AnalyticsManager().logEvent(ANALYTICS_EVENTS.NAVIGATION, user);
        onKeyPress({ keyCode: PLAYER.ENTER });
    }

    const handleSearchClick = () => {
        setCurrentPageUnderMenu(CURRENT_PAGE.SEARCH);
    }

    const handleProfileClick = () => {
        setShowProfile(true);
    }

    const onConfirmLogout = async () => {
        setShowConfirmLogout(false);
        // Logout logic
        try {
            let ipaddressRes = await fetch('https://api.ipify.org?format=json');
            let ipaddress = await ipaddressRes.json().then((data) => data['ip']);
            let res = await removeDevice(user._id, ipaddress);
            // Analytics event
            AnalyticsManager().logEvent(ANALYTICS_EVENTS.LOGOUT, user);
            utility.clearLocalStorage();
            dispatch(resetApplication());
            navigate('/loginWeb');
            console.log(res.message);
        } catch (error) {
            console.log("error while logout ", error.message);
        }

    }

    const handleLoginClick = async () => {
        if (isLoginRef.current) {
            setShowConfirmLogout(true);
        } else {
            // Login logic
            utility.deleteValue(LOCAL_STORAGE_KEY.user);
            navigate('/loginWeb');
        }
    }

    // Filter out search and login from menu items as they'll be separate buttons
    const filteredMenu = menu.filter(item => item._id !== "search" && item._id !== "login" && item._id !== "logout");

    return (
        <>
            <div
                onMouseEnter={() => setOnMouseFocus(true)}
                onMouseLeave={() => setOnMouseFocus(false)}
                style={{
                    width: "100%",
                    height: "60px",
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    paddingLeft: "30px",
                    paddingRight: "30px",
                    position: "fixed",
                    top: "0",
                    left: "0",
                    zIndex: "1000",
                    transition: "all 0.23s ease-in-out",
                    backdropFilter: "blur(10px)"
                }}

                hasFocusedChild={hasFocusedChild}
            >
                {/* Left Section - Logo and Menu Items */}
                <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
                    <NmLogo
                        src={ottSetting?.logo ?? ""}
                        width={ottSetting?.logoSize ?? 25}
                        showCrown={user?.PaymentPlan?.length > 0 ?? false}
                    />

                    {/* Menu Items right after logo */}
                    <div
                        ref={menuContainerRef}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            marginLeft: "40px",
                            position: "relative"
                        }}
                    >
                        {filteredMenu.map((item, index) => (
                            <MenuItem
                                key={index}
                                onClick={onClick}
                                onMouseFocus={onMouseFocus}
                                hasFocusedChild={hasFocusedChild}
                                menuSettings={ottSetting.themeData.menu}
                                item={item}
                                index={index}
                                setSelectedMenu={setSelectedMenu}
                                currentPage={currentPage}
                            />
                        ))}

                        {/* Sliding underline */}
                        <div style={underlineStyle} />
                    </div>
                </div>

                {/* Right Section - Search and Login */}
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    minWidth: "200px",
                    justifyContent: "flex-end",
                    gap: "15px"
                }}>
                    <ActionButton
                        icon="search"
                        text=""
                        onClick={handleSearchClick}
                        focused={searchFocused}
                        onMouseEnter={() => setSearchFocused(true)}
                        onMouseLeave={() => setSearchFocused(false)}
                    />
                    {isLoginRef.current && (
                        <>
                            <TooltipWeb text={user?.Name || "Profile"}>
                                <RoundButtonWeb
                                    icon="person"
                                    onClick={handleProfileClick}
                                    focused={profileFocused}
                                    onMouseEnter={() => setProfileFocused(true)}
                                    onMouseLeave={() => setProfileFocused(false)}
                                />
                            </TooltipWeb>
                            {(!ottSetting?.disableProfileSelection) &&
                                <TooltipWeb text={selectedProfile?.Description || "Profile"}>
                                    <Smiley size="40px" profile={selectedProfile} margin="0px 10px 0px 0px" showName={false} on overflow="hidden" onClick={() => { navigate('/profile') }} />
                                </TooltipWeb>
                            }
                        </>
                    )
                    }
                    <ActionButton
                        icon={isLoginRef.current ? "logout" : "login"}
                        text={isLoginRef.current ? "LOGOUT" : "LOGIN"}
                        onClick={handleLoginClick}
                        focused={loginFocused}
                        onMouseEnter={() => setLoginFocused(true)}
                        onMouseLeave={() => setLoginFocused(false)}
                    />
                </div>
            </div>
            {/* Add CSS for animation */}
            <style>{`
                @keyframes slideIn {
                    from {
                        width: 0%;
                        opacity: 0;
                    }
                    to {
                        width: 80%;
                        opacity: 1;
                    }
                }
            `}</style>
            {true && <LogoutConfirmationBox openExitDialogue={showConfirmLogout} onExitDialogue={setShowConfirmLogout} onConfirmLogout={onConfirmLogout} />}
            {true && <ProfileWeb open={showProfile} onClose={() => setShowProfile(false)} />}
        </>

    );
}